import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"


export default function useAdminSkuMapping(dataRow) {
    const isLoading = useSignal(false)

    const __sendToBack = (extraData={}, oldValue, updateValue) => {
        isLoading.value = true
        postSubmit(`${BACKEND_APIS.ADMIN}/product-review/update-mapping`, {
            item: {
                siteID: dataRow.siteID,
                brandID: dataRow.brandID,
                skuID: dataRow.skuID,
                productID: dataRow.productID,
                productURL: dataRow.productURL
            },
            mapping: {
                brandID: dataRow.brandID,
                skuID: dataRow.skuID,
                productURL: dataRow.productURL,
                skip: dataRow.skip,
                qa: dataRow.qa,
                validated: dataRow.validated,
                ...extraData
            }
        }).then(() => isLoading.value = false).catch(() => {
            updateValue(oldValue)
            isLoading.value = false
        })
    }

    const handleValidate = useCallback((newValue, updateValue) =>
        __sendToBack({ validated: newValue }, !newValue, updateValue), [JSON.stringify(dataRow)])

    const handleSkip = useCallback((newValue, updateValue) =>
        __sendToBack({ skip: newValue }, !newValue, updateValue), [JSON.stringify(dataRow)])

    return {
        isLoading: isLoading.value,
        handleValidate,
        handleSkip
    }
}